import { HelperService } from 'src/app/core/service/helper.service';
import { Organization } from './../../../core/model/organization';
import { AuthenticationService } from './../../../core/authentication/authentication.service';
import { Dictionary, Code } from './../../../core/model/dictionary';
import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommunityProviderProgramEdit } from '../../model/community-provider-program';
import { merge, reject, omit } from 'lodash';
import { CommunityProviderProgramValidators } from 'src/app/core/validators/community-provider-program.validator';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { UserService } from 'src/app/core/service/user.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { CommunityServiceCategoryService } from 'src/app/core/service/community-service-category.service';
import { GroupResult, groupBy } from '@progress/kendo-data-query';
import { sortBy } from 'lodash';
import { AppointmentService } from 'src/app/core/service/appointment.service';
import moment from 'moment';
import { OrganizationService } from 'src/app/core/service/organization.service';
import { ChannelService } from 'src/app/core/service/channel.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingService } from 'src/app/core/service/setting.service';
import { MemberService } from 'src/app/core/service/member.service';
import { AddressValidatorComponent } from 'src/app/shared/address-validator/address-validator.component';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { CommunityProviderProgramService } from 'src/app/core/service/community-provider-program.service';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GridEventHandler } from 'src/app/core/model/grid-settings';
import { ExtensionService } from 'src/app/core/service/extension.service';
import { Guid } from 'guid-typescript';

@Component({
  standalone: false,
  selector: 'app-community-provider-program-edit',
  templateUrl: './community-provider-program-edit.component.html',
  styleUrls: ['./community-provider-program-edit.component.scss']
})
export class CommunityProviderProgramEditComponent implements OnInit, AfterViewChecked
{
  @ViewChild('addressValidator') public addressValidator: AddressValidatorComponent;
  @ViewChild('tabstrip') public tabstrip: TabStripComponent;

  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<CommunityProviderProgramEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;
  public userOrganization: Organization;
  public organizations = [];
  public submittingOrganizations = [];
  public addressChanged = false;
  public addressAPIEnabled = false;
  public saving = false;
  public serviceToSave: any;
  public currentDirectoryManagerEmail: any;
  public types: any[] = [];
  public assigningAuthorities: any[] = [];

  /**
   * Is restricted to logged in user org?
   */
  public isRestrictedOrganization = false;
  public isRestrictedSubmittingOrganization = false;

  /**
   * All language codes
   */
  public allLanguages = [];

  /**
   * Filtered list of languages for drop-down.
   */
  public languagesFiltered: Dictionary[] = [];

  /**
   * All license codes
   */
  public allLicenses = [];

  /**
   * Filtered list of licenses for drop-down.
   */
  public licensesFiltered: Dictionary[] = [];

  /**
   * All Provider Taxonomy codes
   */
  public allProviderTaxonomies = [];

  /**
   * Filtered list of Provider Taxonomies for drop-down.
   */
  public providerTaxonomiesFiltered: Dictionary[] = [];

  /**
   * All area served cities codes
   */
  public allAreaServedCities = [];

  /**
   * Filtered list of area served cities for drop-down.
   */
  public areaServedCitiesFiltered: Dictionary[] = [];

  /**
   * All area served counties codes
   */
  public allAreaServedCounties = [];

  /**
   * Filtered list of area served cities for drop-down.
   */
  public areaServedCountiesFiltered: Dictionary[] = [];

  /**
   * All area served zipcodes codes
   */
  public allAreaServedZipCodes = [];

  /**
   * Filtered list of area served cities for drop-down.
   */
  public areaServedZipCodesFiltered: Dictionary[] = [];

  /**
   * All income requirements codes
   */
  public allIncomeRequirements = [];

  /**
   * Filtered list of income requirements for drop-down.
   */
  public incomeRequirementsFiltered: Dictionary[] = [];

  /**
   * All payment methods codes
   */
  public allPaymentMethods = [];

  /**
   * Filtered list of payment methods for drop-down.
   */
  public paymentMethodsFiltered: Dictionary[] = [];

  /**
   * All targeted demographics codes
   */
  public allTargetedDemographics = [];

  /**
   * Filtered list of targeted demographics for drop-down.
   */
  public targetedDemographicsFiltered: Dictionary[] = [];

  /**
   * All targeted populations codes
   */
  public allTargetedPopulations = [];

  /**
   * Filtered list of targeted populations for drop-down.
   */
  public targetedPopulationsFiltered: Dictionary[] = [];

  /**
   * Current search term entered from a comboxbox
   */
  public searchTerm: string;

  /**
   * All Enhanced Service codes
   */
  public allEnhancedServices = [];

  /**
   * Filtered list of Enhanced Services for drop-down.
   */
  public enhancedServicesFiltered: Dictionary[] = [];

  /**
   * Maximum number of items for virtualization. This is to accelerate the DOM performance.
   */
  public virtualLanguage: any = { itemHeight: 30 };
  public virtualOrganization: any = { itemHeight: 30 };
  public virtualSubmittingOrganization: any = { itemHeight: 30 };
  public virtualAreaServedCity: any = { itemHeight: 30 };
  public virtualAreaServedCounty: any = { itemHeight: 30 };
  public virtualAreaServedZipCode: any = { itemHeight: 30 };
  public virtualLicense: any = { itemHeight: 30 };
  public virtualTargetedDemographic: any = { itemHeight: 30 };
  public virtualTargetedPopulation: any = { itemHeight: 30 };
  public virtualProviderTaxonomy: any = { itemHeight: 30 };
  public virtualIncomeRequirement: any = { itemHeight: 30 };
  public virtualPaymentMethod: any = { itemHeight: 30 };
  public virtualEnhancedService: any = { itemHeight: 30 };

  public communityServiceCategories = [];
  public groupedCommunityServiceCategories: GroupResult[] = [];
  public states: Code[] = [];
  public countries: Code[] = [];
  public times: UntypedFormArray;
  public days: Array<{ text: string; value: string }>;
  public allChannels = [];
  public groupedChannels: GroupResult[] = [];
  public resourceStatuses = [];
  public phoneNumberMask: string;
  public patientLabel = {};
  public emergencyContactMask: string;

  public viewExtensions: GridViewManager;
  public communityServiceExtensionFormGroup: any = null;
  public communityServiceExtensionsEditable = false;
  public extensionsByCategory = [];
  public extensionsByCategoryAndOrganization = [];
  public extensionsByCategoryAndOrganizationUnused = [];

  public urlPattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

  private daysConst = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
  private orgMismatchedText: string;
  private communityProviderProgramEdit: CommunityProviderProgramEdit;
  private nonAsciiMessage: string;

  private requiredCommunityResources = [];
  private communityResources: Array<{ text: string; value: string; key: string }>;

  constructor(
    private communityProviderProgramValidators: CommunityProviderProgramValidators,
    private dictionaryService: DictionaryService,
    private changeDetectorRef: ChangeDetectorRef,
    private communityServiceCategoryService: CommunityServiceCategoryService,
    private authService: AuthenticationService,
    private userService: UserService,
    private helperService: HelperService,
    private messageHandlerService: MessageHandlerService,
    private appointmentService: AppointmentService,
    private organizationService: OrganizationService,
    private fb: UntypedFormBuilder,
    private channelService: ChannelService,
    private translate: TranslateService,
    private settingService: SettingService,
    private memberService: MemberService,
    private communityProviderProgramService: CommunityProviderProgramService,
    private extensionService: ExtensionService,)
  {
    this.getOrganizations();
    this.loadLookups();
    this.viewExtensions = new GridViewManager(99999);
    this.viewExtensions.setData([]);
  }

  public get longitude(): UntypedFormControl
  {
    return this.editForm.get('longitude');
  }

  public get latitude(): UntypedFormControl
  {
    return this.editForm.get('latitude');
  }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get description(): UntypedFormControl
  {
    return this.editForm.get('description');
  }

  public get cost(): UntypedFormControl
  {
    return this.editForm.get('cost');
  }

  public get eligibility(): UntypedFormControl
  {
    return this.editForm.get('eligibility');
  }

  public get languages(): UntypedFormControl
  {
    return this.editForm.get('languages');
  }

  public get enhancedServices(): UntypedFormControl
  {
    return this.editForm.get('enhancedServices');
  }

  public get serviceCategory(): UntypedFormControl
  {
    return this.editForm.get('serviceCategory');
  }

  public get streetLine(): UntypedFormControl
  {
    return this.editForm.get('streetLine');
  }

  public get streetLineAdditional(): UntypedFormControl
  {
    return this.editForm.get('streetLineAdditional');
  }

  public get city(): UntypedFormControl
  {
    return this.editForm.get('city');
  }

  public get postalCode(): UntypedFormControl
  {
    return this.editForm.get('postalCode');
  }

  public get state(): UntypedFormControl
  {
    return this.editForm.get('state');
  }

  public get country(): UntypedFormControl
  {
    return this.editForm.get('country');
  }

  public get organization(): UntypedFormControl
  {
    return this.editForm.get('organization');
  }

  public get channel(): UntypedFormControl
  {
    return this.editForm.get('channel');
  }

  public get email(): UntypedFormControl
  {
    return this.editForm.get('email');
  }

  public get url(): UntypedFormControl
  {
    return this.editForm.get('url');
  }

  public get faxNumber(): UntypedFormControl
  {
    return this.editForm.get('faxNumber');
  }

  public get phoneNumber(): UntypedFormControl
  {
    return this.editForm.get('phoneNumber');
  }

  public get referralEmail(): UntypedFormControl
  {
    return this.editForm.get('referralEmail');
  }

  public get referralUrl(): UntypedFormControl
  {
    return this.editForm.get('referralUrl');
  }

  public get referralFaxNumber(): UntypedFormControl
  {
    return this.editForm.get('referralFaxNumber');
  }

  public get referralPhoneNumber(): UntypedFormControl
  {
    return this.editForm.get('referralPhoneNumber');
  }

  public get referralContactName(): UntypedFormControl
  {
    return this.editForm.get('referralContactName');
  }

  public get referralEmergencyNumber(): UntypedFormControl
  {
    return this.editForm.get('referralEmergencyNumber');
  }

  public get referralExtension(): UntypedFormControl
  {
    return this.editForm.get('referralExtension');
  }

  public get programContactName(): UntypedFormControl
  {
    return this.editForm.get('programContactName');
  }

  public get acceptingDisabledPatients(): UntypedFormControl
  {
    return this.editForm.get('acceptingDisabledPatients');
  }

  public get acceptingElectronicReferrals(): UntypedFormControl
  {
    return this.editForm.get('acceptingElectronicReferrals');
  }

  public get acceptingNewPatients(): UntypedFormControl
  {
    return this.editForm.get('acceptingNewPatients');
  }

  public get acceptingSelfReferrals(): UntypedFormControl
  {
    return this.editForm.get('acceptingSelfReferrals');
  }

  public get alias(): UntypedFormControl
  {
    return this.editForm.get('alias');
  }

  public get alertDescription(): UntypedFormControl
  {
    return this.editForm.get('alertDescription');
  }

  public get applicationProcess(): UntypedFormControl
  {
    return this.editForm.get('applicationProcess');
  }

  public get areaServedCities(): UntypedFormControl
  {
    return this.editForm.get('areaServedCities');
  }

  public get areaServedCounties(): UntypedFormControl
  {
    return this.editForm.get('areaServedCounties');
  }

  public get areaServedZipCodes(): UntypedFormControl
  {
    return this.editForm.get('areaServedZipCodes');
  }

  public get capacity(): UntypedFormControl
  {
    return this.editForm.get('capacity');
  }

  public get documentationRequired(): UntypedFormControl
  {
    return this.editForm.get('documentationRequired');
  }

  public get incomeRequirements(): UntypedFormControl
  {
    return this.editForm.get('incomeRequirements');
  }

  public get lgbtq(): UntypedFormControl
  {
    return this.editForm.get('lgbtq');
  }

  public get licenses(): UntypedFormControl
  {
    return this.editForm.get('licenses');
  }

  public get paymentMethods(): UntypedFormControl
  {
    return this.editForm.get('paymentMethods');
  }

  public get resourceStatus(): UntypedFormControl
  {
    return this.editForm.get('resourceStatus');
  }

  public get submittingOrganization(): UntypedFormControl
  {
    return this.editForm.get('submittingOrganization');
  }

  public get targetedDemographics(): UntypedFormControl
  {
    return this.editForm.get('targetedDemographics');
  }

  public get targetedPopulations(): UntypedFormControl
  {
    return this.editForm.get('targetedPopulations');
  }

  public get providerTaxonomies(): UntypedFormControl
  {
    return this.editForm.get('providerTaxonomies');
  }

  public get directoryManagerName(): UntypedFormControl
  {
    return this.editForm.get('directoryManagerName');
  }

  public get directoryManagerEmail(): UntypedFormControl
  {
    return this.editForm.get('directoryManagerEmail');
  }

  public get directoryManagerNotificationPreference(): UntypedFormControl
  {
    return this.editForm.get('directoryManagerNotificationPreference');
  }

  public get ableToConductScreenings(): UntypedFormControl
  {
    return this.editForm.get('ableToConductScreenings');
  }

  public get informationalOnly(): UntypedFormControl
  {
    return this.editForm.get('informationalOnly');
  }

  public get allowDuplicateReferrals(): UntypedFormControl
  {
    return this.editForm.get('allowDuplicateReferrals');
  }

  public get extensions(): UntypedFormControl
  {
    return this.editForm.get('extensions');
  }

  @Input() public set model(communityProviderEdit: CommunityProviderProgramEdit)
  {
    this.initModel(communityProviderEdit);
  }

  public ngOnInit(): void
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.phoneNumberMask = sessionSetting.phoneMask;
        this.emergencyContactMask = '000';
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
        this.requiredCommunityResources =
          sessionSetting.requiredCommunityResources ? sessionSetting.requiredCommunityResources.split(',') : [];
        this.communityResources = this.memberService.communityResources;
        this.addressAPIEnabled = sessionSetting.addressAPIEnabled;
        this.communityServiceExtensionsEditable = (sessionSetting.addUpdateExtensionsRoles !== '') ?
          this.userService.isRoleInList(this.authService.currentUser.role, sessionSetting.addUpdateExtensionsRoles) : false;
      }
    });

    this.channelService.getMinimalChannels('?referralOnly=true').subscribe({
      next: (channelData) =>
      {
        this.allChannels = channelData;
        this.allChannels.forEach(d =>
        {
          d.programName = d.program.name;
        });
        this.setGroupedChannels();
      }
    });

    this.translate.get(['CHANNEL-VS-PROGRAM-ORGANIZATION-MISMATCHED', 'COMMUNITY-PROGRAM-NON-ASCII-CHARACTERS-FOUND']).subscribe({
      next: (res) =>
      {
        this.orgMismatchedText = res['CHANNEL-VS-PROGRAM-ORGANIZATION-MISMATCHED'];
        this.nonAsciiMessage = res['COMMUNITY-PROGRAM-NON-ASCII-CHARACTERS-FOUND'];
      }
    });
  }

  public ngAfterViewChecked(): void
  {
    this.changeDetectorRef.detectChanges();
  }

  public onSave(e: Event): void
  {
    if (!this.isNew && this.currentDirectoryManagerEmail !== null && this.directoryManagerEmail.value === '')
    {
      let pendingCorrections = null;
      this.communityServiceCategoryService.findCorrectionsByDirectoryManager(this.communityProviderProgramEdit.id, this.currentDirectoryManagerEmail.value).subscribe({
        next: (response) =>
        {
          pendingCorrections = response;
          if (pendingCorrections)
          {
            this.messageHandlerService.displayWarning('PENDING-CORRECTIONS-DETECTED');
            this.tabstrip.selectTab(2);
            return;
          }
          else
          {
            this.onSaveBuildObject(e);
          }
        }
      });
    }
    else
    {
      this.onSaveBuildObject(e);
    }
  }

  public onSaveBuildObject(e: Event): void
  {
    e.preventDefault();

    this.communityProviderProgramEdit.extensions = this.viewExtensions.gridData.data;
    // Must remove temporary guid from extensions
    this.communityProviderProgramEdit.extensions.forEach((e) => { if (!Number.isFinite(e.id)) { e.id = null; } });

    const objectToPersist = merge(this.communityProviderProgramEdit, omit(this.editForm.value, 'extensions'));

    objectToPersist.longitude = this.longitude.value;
    objectToPersist.latitude = this.latitude.value;

    // Set Channel
    if (this.channel.value && this.channel.value.id > 0)
    {
      objectToPersist.channel = this.channel.value;
    }
    else
    {
      objectToPersist.channel = null;
    }

    // Set Organization
    objectToPersist.organization = this.organization.value;

    // Validate selected Organization belong to Channel/Program's Organization (if specified)
    if (objectToPersist.channel !== null)
    {
      // Channel selection is using minimal resultset therefore we use organizationId/organizationName properties.
      // When not changed, we use the loaded organization object.
      let channelOrgId = null;
      let channelOrgName = null;
      if (objectToPersist.channel.program.organizationId !== null && objectToPersist.channel.program.organizationId !== undefined)
      {
        channelOrgId = objectToPersist.channel.program.organizationId;
        channelOrgName = objectToPersist.channel.program.organizationName;
      }
      else if (objectToPersist.channel.program.organization !== null && objectToPersist.channel.program.organization !== undefined)
      {
        channelOrgId = objectToPersist.channel.program.organization.id;
        channelOrgName = objectToPersist.channel.program.organization.name;
      }

      if (channelOrgId !== null && objectToPersist.organization.id !== channelOrgId)
      {
        const messageText = this.orgMismatchedText
          .replace('{{org1}}', objectToPersist.organization.name)
          .replace('{{org2}}', channelOrgName);
        this.messageHandlerService.displayDirectMessage('error', messageText);
        return;
      }
    }

    // Languages
    objectToPersist.languages = this.languages.value;

    // Enhanced Services
    objectToPersist.enhancedServices = this.enhancedServices.value;

    // Licenses
    objectToPersist.licenses = this.licenses.value;

    // Provider Taxonomies
    objectToPersist.providerTaxonomies = this.providerTaxonomies.value;

    // Set address object and clean up
    this.setAddress(objectToPersist);

    // Clean up opening times
    this.setOpeninigTimes(objectToPersist);

    // Clean up wait times
    this.setWaitTimes(objectToPersist);

    // Clean up websites
    this.setWebsites(objectToPersist);

    // Clean up other identifiers
    this.setOtherIdentifiers(objectToPersist);

    //Set areas served cities
    objectToPersist.areaServedCities = this.areaServedCities.value;

    //Set areas served cities
    objectToPersist.areaServedCounties = this.areaServedCounties.value;

    //Set areas served zip codes
    objectToPersist.areaServedZipCodes = this.areaServedZipCodes.value;

    // Set status
    objectToPersist.resourceStatus = this.resourceStatus.value;

    // Set submitting organization
    objectToPersist.submittingOrganization = this.submittingOrganization.value;

    // Set income requirements
    objectToPersist.incomeRequirements = this.incomeRequirements.value;

    // Set payment methods
    objectToPersist.paymentMethods = this.paymentMethods.value;

    objectToPersist.targetedDemographics = this.targetedDemographics.value;
    objectToPersist.targetedPopulations = this.targetedPopulations.value;

    this.performServiceSave(objectToPersist);
  }

  /**
   * Perform the Service Save.
   *
   */
  public saveService(): void
  {
    this.communityProviderProgramService.saveCommunityProviderProgram(this.serviceToSave, this.isNew, this.serviceToSave.id).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('COMMUNITY-PROVIDER-PROGRAM-SAVED-SUCCESSFULLY');
        this.addressChanged = false;
        this.saving = false;
        this.editFormActive = false;
        this.save.emit();
      },
      error: (error) =>
      {
        if (error !== null && error.error !== null && error.error.message !== null && error.error.message.startsWith('transient.error-non-ascii-characters-found'))
        {
          const index = error.error.message.indexOf(":");
          const strErrors = error.error.message.substring(index + 1).split(',');
          let fields = '';
          for (let i = 0; i < strErrors.length; i++)
          {
            switch (strErrors[i])
            {
              case 'name': fields = fields === '' ? fields.concat(this.translate.instant('PROGRAM-NAME')) : fields.concat(', ').concat(this.translate.instant('PROGRAM-NAME')); break;
              case 'description': fields = fields === '' ? fields.concat(this.translate.instant('DESCRIPTION')) : fields.concat(', ').concat(this.translate.instant('DESCRIPTION')); break;
              case 'eligibility': fields = fields === '' ? fields.concat(this.translate.instant('ELIGIBILITY')) : fields.concat(', ').concat(this.translate.instant('ELIGIBILITY')); break;
              case 'cost': fields = fields === '' ? fields.concat(this.translate.instant('COST')) : fields.concat(', ').concat(this.translate.instant('COST')); break;
              case 'street': fields = fields === '' ? fields.concat(this.translate.instant('STREET')) : fields.concat(', ').concat(this.translate.instant('STREET')); break;
              case 'street2': fields = fields === '' ? fields.concat(this.translate.instant('ADDRESS-LINE-2')) : fields.concat(', ').concat(this.translate.instant('ADDRESS-LINE-2')); break;
              case 'city': fields = fields === '' ? fields.concat(this.translate.instant('CITY')) : fields.concat(', ').concat(this.translate.instant('CITY')); break;
              case 'zip': fields = fields === '' ? fields.concat(this.translate.instant('POSTAL-CODE')) : fields.concat(', ').concat(this.translate.instant('POSTAL-CODE')); break;
            }
          }
          this.messageHandlerService.displayDirectMessage('error', this.nonAsciiMessage.replace('{{fieldNames}}', fields));
          this.saving = false;
        }
        else
        {
          this.messageHandlerService.displayError('COMMUNITY-PROVIDER-PROGRAM-SAVE-ERROR');
          this.addressChanged = false;
          this.saving = false;
          this.editFormActive = false;
        }
      }
    });
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  /**
   * Address change event from Address Validator component.
   *
   * @param event Address data being selected to apply.
   */
  public changeAddress(event: any): void
  {
    // Override the address based on Address API response.
    if (event.confirmation === 'recommended')
    {
      // Force dirty to change state
      this.editForm.markAsDirty();

      // Set form properties
      this.streetLine.setValue(event.line1);
      this.streetLineAdditional.setValue(event.line2);
      this.state.setValue(event.postalAddress && event.postalAddress.administrativeArea ?
        this.states.find(x => x.code === event.postalAddress.administrativeArea) : null);
      this.city.setValue(event.postalAddress && event.postalAddress.locality ? event.postalAddress.locality : null);
      this.postalCode.setValue(event.postalAddress && event.postalAddress.postalCode ? event.postalAddress.postalCode : null);
      this.latitude.setValue(event.geocode && event.geocode.location ? event.geocode.location.latitude : null);
      this.longitude.setValue(event.geocode && event.geocode.location ? event.geocode.location.longitude : null);

      if (event.postalAddress && event.postalAddress.regionCode)
      {
        this.country.setValue(this.countries.find(x => x.alternateCode === event.postalAddress.regionCode));
      }
      this.addressChanged = false;    // Mark address unchanged to avoid opening modal again unless it is manually changed again.
    }
    else
    {
      this.latitude.setValue(null);
      this.longitude.setValue(null);
    }

    // If autoSave, then set patient object and save.
    if (event.autoSave)
    {
      this.setAddress(this.serviceToSave);
      this.saveService();
    }
  }

  /**
   * Manual Address Validation. No autoSave will be performed.
   */
  public validateAddress(): void
  {
    this.addressValidator.execute(false, this.streetLine.value, this.streetLineAdditional.value, this.city.value,
      this.state.value ? this.state.value.code : null, this.country.value ? this.country.value.code : null, this.postalCode.value);
  }

  /**
   * Filters the languages based on user input.
   */
  public filterLanguages(filter: string): void
  {
    this.searchTerm = filter;
    this.languagesFiltered = this.allLanguages
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  public filterEnhancedServices(filter: string): void
  {
    this.searchTerm = filter;
    this.enhancedServicesFiltered = this.allEnhancedServices
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the licenses based on user input.
   */
  public filterLicenses(filter: string): void
  {
    this.searchTerm = filter;
    this.licensesFiltered = this.allLicenses
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the provider taxonomies based on user input.
   */
  public filterProviderTaxonomies(filter: string): void
  {
    this.searchTerm = filter;
    this.providerTaxonomiesFiltered = this.allProviderTaxonomies
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the area served cities based on user input.
   */
  public filterAreaServedCities(filter: string): void
  {
    this.searchTerm = filter;
    this.areaServedCitiesFiltered = this.allAreaServedCities
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the area served cities based on user input.
   */
  public filterAreaServedCounties(filter: string): void
  {
    this.searchTerm = filter;
    this.areaServedCountiesFiltered = this.allAreaServedCounties
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the area served cities based on user input.
   */
  public filterAreaServedZipCodes(filter: string): void
  {
    this.searchTerm = filter;
    this.areaServedZipCodesFiltered = this.allAreaServedZipCodes
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the income requirements based on user input.
   */
  public filterIncomeRequirements(filter: string): void
  {
    this.searchTerm = filter;
    this.incomeRequirementsFiltered = this.allIncomeRequirements
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the payment methods based on user input.
   */
  public filterPaymentMethods(filter: string): void
  {
    this.searchTerm = filter;
    this.paymentMethodsFiltered = this.allPaymentMethods
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the targeted demographics based on user input.
   */
  public filterTargetedDemographics(filter: string): void
  {
    this.searchTerm = filter;
    this.targetedDemographicsFiltered = this.allTargetedDemographics
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Filters the targeted populations based on user input.
   */
  public filterTargetedPopulations(filter: string): void
  {
    this.searchTerm = filter;
    this.targetedPopulationsFiltered = this.allTargetedPopulations
      .filter(user => user.displayName.toLowerCase().includes(filter.toLowerCase()));
  }

  /**
   * Check if item from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public itemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return !itemArgs.dataItem.active;
  }

  /**
   * Check if item from dropdown is disabled or enabled.
   *
   * @returns boolean
   */
  public channelItemDisabled(itemArgs: { dataItem: any; index: number }): boolean
  {
    return itemArgs.dataItem.status !== 'Online';
  }

  public addTime(id: number = null, version = 0, day: string = null, from: Date = null, to: Date = null): void
  {
    this.editForm.controls.openingTimes.push(this.initTime(id, version, day, from, to));
    this.editForm.markAsDirty();
  }

  public addWaitTime(id: number = null, version = 0, locationID: string = null, waitTime: string = null): void
  {
    this.editForm.controls.waitTimes.push(this.initWaitTime(id, version, locationID, waitTime));
    this.editForm.markAsDirty();
  }

  public addWebsite(id: number = null, version = 0, name: string = null, url: string = null): void
  {
    this.editForm.controls.websites.push(this.initWebsite(id, version, name, url));
    this.editForm.markAsDirty();
  }

  public addOtherIdentifier(id: number = null, version = 0, assigningAuthority: any = null, identifierValue: string = null,
    type: any = null): void  
  {
    this.editForm.controls.otherIdentifiers.push(this.initOtherIdentifier(id, version, assigningAuthority,
      identifierValue, type));
    this.editForm.markAsDirty();
  }

  public removeTime(i: number, id: number): void
  {
    const control = this.editForm.controls.openingTimes;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.communityProviderProgramEdit.openingTimes = reject(this.communityProviderProgramEdit.openingTimes, rejectedId);
    }
    control.removeAt(i);
    this.editForm.touched = true;
    this.editForm.markAsDirty();
  }

  public removeWaitTime(i: number, id: number): void
  {
    const control = this.editForm.controls.waitTimes;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.communityProviderProgramEdit.waitTimes = reject(this.communityProviderProgramEdit.waitTimes, rejectedId);
    }
    control.removeAt(i);
    this.editForm.touched = true;
    this.editForm.markAsDirty();
  }

  public removeWebsite(i: number, id: number): void
  {
    const control = this.editForm.controls.websites;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.communityProviderProgramEdit.websites = reject(this.communityProviderProgramEdit.websites, rejectedId);
    }
    control.removeAt(i);
    this.editForm.touched = true;
    this.editForm.markAsDirty();
  }

  public removeOtherIdentifier(i: number, id: number): void
  {
    const control = this.editForm.controls.otherIdentifiers;
    // If this id was already persisted, we must remove
    if (id > 0)
    {
      const rejectedId: any = {};
      rejectedId.id = id;
      this.communityProviderProgramEdit.otherIdentifiers = reject(this.communityProviderProgramEdit.otherIdentifiers, rejectedId);
    }
    control.removeAt(i);
    this.editForm.touched = true;
    this.editForm.markAsDirty();
  }

  public isValidUrl(): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return this.url.value !== undefined && this.url.value && regEx.test(this.url.value);
  }

  public openUrl(): void
  {
    if (this.isValidUrl())
    {
      window.open(this.url.value);
    }
  }

  public isValidReferralUrl(): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return this.referralUrl.value !== undefined && this.referralUrl.value && regEx.test(this.referralUrl.value);
  }

  public openReferralUrl(): void
  {
    if (this.isValidReferralUrl())
    {
      window.open(this.referralUrl.value);
    }
  }

  public isValidWebsiteUrl(websiteUrl: string): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return websiteUrl !== undefined && websiteUrl && regEx.test(websiteUrl);
  }

  public openWebsiteUrl(websiteUrl: string): void
  {
    if (this.isValidWebsiteUrl(websiteUrl))
    {
      window.open(websiteUrl);
    }
  }

  /**
   * Check if the Community Resource is required.
   *
   * @param communityResource Community Resource value to check.
   * @returns True if the Community Resource is required.
   */
  public isRequired(communityResource: string): boolean
  {
    if (communityResource == "DIRECTORY_MANAGER_NOTIFICATION_PREFERENCE")
    {
      return this.requiredCommunityResources.indexOf("DIRECTORY_MANAGER_EMAIL") !== -1;
    }
    else
    {
      return this.requiredCommunityResources.indexOf(communityResource) !== -1;
    }
  }

  /**
   * This is conditionaly show the *
   */
  public requiredLabel(communityResource: string): string
  {
    return this.isRequired(communityResource) ||
      (communityResource === 'DIRECTORY_MANAGER_NOTIFICATION_PREFERENCE' && this.directoryManagerEmail.value) ? '*' : '';
  }

  public requiredText(communityResource: string): string
  {
    const foundCommunityResource = this.communityResources.find(x => x.value === communityResource);
    if (foundCommunityResource)
    {
      return foundCommunityResource.text;
    }
    else
    {
      return communityResource;
    }
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public communityServiceExtensionsDataStateChange(state: DataStateChangeEvent): void
  {
    this.viewExtensions.setState(state);
  }

  /**
   * Handles the add new row event of the Kendo grid for case extension.
   * Adds a new row to the grid, and creates a FormGroup for data input.
   */
  public communityServiceExtensionAddHandler(event: GridEventHandler): void
  {
    this.communityServiceExtensionFormGroup = this.fb.group(
      {
        isNew: true,
        id: Guid.create().toString(),
        settingExtension: [{ value: null, disabled: false }, Validators.required],
        value: [{ value: null, disabled: false }, Validators.required],
        editing: true
      }
    );

    event.sender.addRow(this.communityServiceExtensionFormGroup);

    if (this.organization.value !== undefined)
    {
      this.organizationChange(false);
    }
  }

  /**
   * Handles the edit event of the case extensions grid.
   */
  public communityServiceExtensionEditHandler(event: GridEventHandler): void
  {
    this.communityServiceExtensionFormGroup = this.fb.group(
      {
        isNew: false,
        id: event.dataItem.id,
        value: [event.dataItem.value, Validators.required],
        settingExtension: [event.dataItem.settingExtension, Validators.required],
        editing: true,
      }
    );
    this.organizationChange(false);
    event.sender.editRow(event.rowIndex, this.communityServiceExtensionFormGroup);
  }

  /**
   * Cancelling the patient extension add action.
   *
   * @param event Current row
   */
  public communityServiceExtensionCancelHandler(event: GridEventHandler): void
  {
    event.sender.closeRow(event.rowIndex);
  }

  /**
   * Delete entered patient extension from grid.
   *
   * @param extension Community Service Extension record to remove.
   */
  public deleteCommunityServiceExtension(extension: any): void
  {
    this.extensions.setValue(this.extensions.value.filter(c => c.id !== extension.id));
    this.viewExtensions.setData(this.extensions.value);
    this.editForm.markAsDirty();
  }

  /**
   * Extension organization changed.
   */
  public organizationChange(reset: boolean): void
  {
    if (reset)
    {
      this.extensionsByCategory = [];
      this.extensionsByCategoryAndOrganization = [];
      this.extensionsByCategoryAndOrganizationUnused = [];
    }
    if (this.organization.value)
    {
      this.extensionService.getExtensionsByCategory('COMMUNITY_SERVICE').subscribe({
        next: (data) =>
        {
          this.extensionsByCategory = data;
          this.extensionsByCategoryAndOrganization = this.extensionsByCategory.filter(
            extension => extension.organization === null || extension.organization.id === this.organization.value.id);
          const extensionsInUse = this.viewExtensions.gridData.data;
          this.extensionsByCategoryAndOrganizationUnused = sortBy(
            this.extensionsByCategoryAndOrganization.filter(u => !extensionsInUse.map(m => m.settingExtension.id).includes(u.id)), ['name']);
        },
        error: (errorResponse) =>
        {
          this.messageHandlerService.displayError(errorResponse);
        }
      });
    }
  }

  /**
   * Extension save action.
   *
   * @param event Current record
   */
  public communityServiceExtensionSaveHandler(event: GridEventHandler): void
  {
    this.communityServiceExtensionFormGroup.get('editing').setValue(false);

    // Construct data
    const data: any = {};
    data.id = this.communityServiceExtensionFormGroup.get('id').value;
    data.settingExtension =
      this.extensionsByCategoryAndOrganization.find(x => x.id === this.communityServiceExtensionFormGroup.get('settingExtension').value.id);
    data.value = this.communityServiceExtensionFormGroup.get('value').value;
    data.communityProviderProgramId = this.communityProviderProgramEdit ? this.communityProviderProgramEdit.id : null;

    if (!this.extensions.value) 
    {
      this.extensions.setValue([]);
    }

    if (this.communityServiceExtensionFormGroup.get('isNew').value) 
    {
      this.extensions.value.push(data);
    }
    else
    {
      const currentRowIndex = this.extensions.value.findIndex(x => x.id === data.id);
      if (currentRowIndex >= 0)
      {
        this.extensions.value[currentRowIndex] = data;
      }
    }

    this.viewExtensions.setData(this.extensions.value);

    event.sender.closeRow(event.rowIndex);

    this.editForm.markAsDirty();
  }

  public formatExtensionValue(dataItem: any): string
  {
    return this.extensionService.formatExtensionValue(dataItem);
  }

  private setGroupedChannels(): void
  {
    // Build the grouped Channels
    const groupedChannels = groupBy(this.allChannels, [{ field: 'programName' }]);
    this.groupedChannels.forEach(d =>
    {
      const items = sortBy(d.items, ['name']);
      d.items = items;
    });
    this.groupedChannels = sortBy(groupedChannels, ['value']);
  }

  private setOpeninigTimes(objectToPersist: any): void
  {
    objectToPersist.openingTimes.forEach(d =>
    {
      const from = moment(new Date(d.from).toLocaleTimeString(), ['h:mm:ss A']).format('HH:mm:ss');
      const to = moment(new Date(d.to).toLocaleTimeString(), ['h:mm:ss A']).format('HH:mm:ss');
      d.from = from;
      d.to = to;

      // No need to post the following properties on the server
      delete d.rowId;
      delete d.sort;
    });
  }

  private setWaitTimes(objectToPersist: any): void
  {
    objectToPersist.waitTimes.forEach(d =>
    {
      // No need to post the following properties on the server
      delete d.rowId;
      delete d.sort;
    });
  }

  private setWebsites(objectToPersist: any): void
  {
    objectToPersist.websites.forEach(d =>
    {
      // No need to post the following properties on the server
      delete d.rowId;
      delete d.sort;
    });
  }

  private setOtherIdentifiers(objectToPersist: any): void
  {
    objectToPersist.otherIdentifiers.forEach(d =>
    {
      // No need to post the following properties on the server
      delete d.rowId;
      delete d.sort;
    });
  }

  private setAddress(objectToPersist: any): void
  {
    // Init object if null
    if (objectToPersist.address === null || objectToPersist.address === undefined)
    {
      objectToPersist.address = {};
    }

    objectToPersist.address.streetLine = this.streetLine && this.streetLine.value !== '' ? this.streetLine.value : null;
    objectToPersist.address.streetLineAdditional = this.streetLineAdditional && this.streetLineAdditional.value !== '' ?
      this.streetLineAdditional.value : null;
    objectToPersist.address.city = this.city && this.city.value !== '' ? this.city.value : null;
    objectToPersist.address.postalCode = this.postalCode && this.postalCode.value !== '' ? this.postalCode.value : null;
    objectToPersist.address.state = this.state && this.state.value !== '' ? this.state.value : null;
    objectToPersist.address.country = this.country && this.country.value !== '' ? this.country.value : null;
    objectToPersist.address.longitude = this.longitude && this.longitude.value !== '' ? this.longitude.value : null;
    objectToPersist.address.latitude = this.longitude && this.latitude.value !== '' ? this.latitude.value : null;

    delete objectToPersist.streetLine;
    delete objectToPersist.streetLineAdditional;
    delete objectToPersist.city;
    delete objectToPersist.postalCode;
    delete objectToPersist.state;
    delete objectToPersist.country;
    delete objectToPersist.longitude;
    delete objectToPersist.latitude;
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private loadLookups(): void
  {
    // Change from numeric values to string in this context.
    this.days = this.appointmentService.days;
    let index = 0;
    this.days.forEach(() =>
    {
      this.days[index].value = this.daysConst[index];
      index++;
    });

    // Get languages
    this.dictionaryService.getCachedLanguages().subscribe({
      next: (data) =>
      {
        this.allLanguages = data;
        this.filterLanguages('');
      }
    });

    this.dictionaryService.getCachedEnhancedServices().subscribe({
      next: (data) =>
      {
        this.allEnhancedServices = data;
        this.filterEnhancedServices('');
      }
    });

    // Get licenses
    this.dictionaryService.getCachedLicenses().subscribe({
      next: (data) =>
      {
        this.allLicenses = data;
        this.filterLicenses('');
      }
    });

    // Get provider taxonomies
    this.dictionaryService.getCachedProviderTaxonomies().subscribe({
      next: (data) =>
      {
        data.forEach(d =>
        {
          d.displayName = `${d.displayName} (${d.code})`;
        });
        this.allProviderTaxonomies = sortBy(data, ['displayName']);
        this.filterProviderTaxonomies('');
      }
    });

    // Get Area Served Cities
    this.dictionaryService.getCachedAreaServedCities().subscribe({
      next: (data) =>
      {
        this.allAreaServedCities = data;
        this.filterAreaServedCities('');
      }
    });

    // Get Area Served Counties
    this.dictionaryService.getCachedAreaServedCounties().subscribe({
      next: (data) =>
      {
        this.allAreaServedCounties = data;
        this.filterAreaServedCounties('');
      }
    });

    // Get Area Served Zip Codes
    this.dictionaryService.getCachedAreaServedZipCodes().subscribe({
      next: (data) =>
      {
        this.allAreaServedZipCodes = data;
        this.filterAreaServedZipCodes('');
      }
    });

    // Get Income Requirements
    this.dictionaryService.getCachedIncomeRequirements().subscribe({
      next: (data) =>
      {
        this.allIncomeRequirements = data;
        this.filterIncomeRequirements('');
      }
    });

    // Get Payment Methods
    this.dictionaryService.getCachedPaymentMethods().subscribe({
      next: (data) =>
      {
        this.allPaymentMethods = data;
        this.filterPaymentMethods('');
      }
    });

    // Get Targeted Demographics
    this.dictionaryService.getCachedTargetedDemographics().subscribe({
      next: (data) =>
      {
        this.allTargetedDemographics = data;
        this.filterTargetedDemographics('');
      }
    });

    // Get Targeted Populations
    this.dictionaryService.getCachedTargetedPopulations().subscribe({
      next: (data) =>
      {
        this.allTargetedPopulations = data;
        this.filterTargetedPopulations('');
      }
    });

    // Get user organization
    const user = this.authService.currentUser;
    this.userService.getUserById(user.id, false).subscribe({
      next: (data) =>
      {
        this.userOrganization = data.organization;
        this.isRestrictedOrganization = (data.role === 'ROLE_COMMUNITY_COORDINATOR') || (data.role === 'ROLE_COMMUNITY_ADMIN');
        this.isRestrictedSubmittingOrganization = (data.role === 'ROLE_DIRECTORY_MANAGER');
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    // Get community service categories
    this.communityServiceCategoryService.getCommunityServiceCategoriesList().subscribe({
      next: (data) =>
      {
        this.communityServiceCategories = data;
        this.communityServiceCategories.forEach(d =>
        {
          d.serviceTypeName = d.serviceType.displayName;
        });
        this.groupedCommunityServiceCategories = groupBy(this.communityServiceCategories, [{ field: 'serviceTypeName' }]);
        this.groupedCommunityServiceCategories.forEach(d =>
        {
          const items = sortBy(d.items, ['name']);
          d.items = items;
        });
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });

    this.helperService.getStatesCountriesFromMultipleSources().subscribe({
      next: (responseList) =>
      {
        this.states = responseList[0];
        this.countries = responseList[1];
      }
    });

    //Get statuses
    this.dictionaryService.getResourceStatuses().subscribe({
      next: (data) =>
      {
        this.resourceStatuses = data;
      }
    });

    this.dictionaryService.getCachedCommunityServiceIdentifierTypes().subscribe({
      next: (data) =>
      {
        this.types = data;
      }
    });
    this.dictionaryService.getCachedCommunityServiceIdentifierAssigningAuthority().subscribe({
      next: (data) =>
      {
        this.assigningAuthorities = data;
      }
    });
  }

  private initModel(communityProviderProgram: CommunityProviderProgramEdit)
  {
    if (communityProviderProgram === undefined)
    {
      return;
    }

    // Set the current name used for name async validators
    /*2023-03-02 PR: Disable unique name validation check
    const previousName = this.isNew ? '' : communityProviderProgram.name;*/

    // Create temporary address properties to make a flat properties for the address.
    // This is necessary to not losing values when reseting the form state below.
    communityProviderProgram.streetLine = communityProviderProgram.address ? communityProviderProgram.address.streetLine : null;
    communityProviderProgram.streetLineAdditional = communityProviderProgram.address ?
      communityProviderProgram.address.streetLineAdditional : null;
    communityProviderProgram.city = communityProviderProgram.address ? communityProviderProgram.address.city : null;
    communityProviderProgram.postalCode = communityProviderProgram.address ? communityProviderProgram.address.postalCode : null;
    communityProviderProgram.state = communityProviderProgram.address ? communityProviderProgram.address.state : null;
    communityProviderProgram.country = communityProviderProgram.address ? communityProviderProgram.address.country : null;

    // Set displayName using description and code
    if (communityProviderProgram.providerTaxonomies)
    {
      communityProviderProgram.providerTaxonomies.forEach(d =>
      {
        const newDisplayName = `${d.displayName} (${d.code})`;
        d.displayName = newDisplayName;
      });
    }

    // Set form
    this.editForm = this.fb.group({
      id: [communityProviderProgram.id],
      name: [
        { value: '', disabled: false },
        {
          validators: this.getFieldValidators('NAME'),
          /*2023-03-02 PR: Disable unique name validation check
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.communityProviderProgramValidators
              .validateCommunityServiceCategoryNameUnique(this.editForm.get('name'), previousName)*/
        },
      ],
      languages: [{
        value: communityProviderProgram.languages, disabled: false
      }, { validators: this.getFieldValidators('LANGUAGES') }],
      enhancedServices: [{
        value: communityProviderProgram.enhancedServices, disabled: false
      }, { validators: this.getFieldValidators('ENHANCED_SERVICE_ELIGIBILITY') }],
      description: [{
        value: communityProviderProgram.description, disabled: false
      }, { validators: this.getFieldValidators('DESCRIPTION') }],
      cost: [{
        value: communityProviderProgram.cost, disabled: false
      }, { validators: this.getFieldValidators('COST') }],
      eligibility: [{
        value: communityProviderProgram.eligibility, disabled: false
      }, { validators: this.getFieldValidators('ELIGIBILITY') }],
      serviceCategory: [{
        value: communityProviderProgram.serviceCategory, disabled: false
      }, { validators: this.getFieldValidators('SERVICE_CATEGORY') }],
      organization: [{
        value: communityProviderProgram.organization, disabled: false
      }, { validators: this.getFieldValidators('ORGANIZATION') }],
      programContactName: [{
        value: communityProviderProgram.programContactName
      }, { validators: this.getFieldValidators('PROGRAM_CONTACT_NAME') }],
      phoneNumber: [{
        value: communityProviderProgram.phoneNumber
      }, { validators: this.getFieldValidators('PROGRAM_CONTACT_PHONE') }],
      faxNumber: [{
        value: communityProviderProgram.faxNumber
      }, { validators: this.getFieldValidators('PROGRAM_CONTACT_FAX') }],
      email: [{
        value: communityProviderProgram.email
      }, { validators: this.getFieldValidators('PROGRAM_CONTACT_EMAIL') }],
      url: [{
        value: communityProviderProgram.url, disabled: false
      }, { validators: this.getFieldValidators('PROGRAM_CONTACT_URL') }],
      referralContactName: [{
        value: communityProviderProgram.referralContactName
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_NAME') }],
      referralPhoneNumber: [{
        value: communityProviderProgram.referralPhoneNumber
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_PHONE') }],
      referralFaxNumber: [{
        value: communityProviderProgram.referralFaxNumber
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_FAX') }],
      referralEmail: [{
        value: communityProviderProgram.referralEmail
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_EMAIL') }],
      referralUrl: [{
        value: communityProviderProgram.referralUrl, disabled: false
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_URL') }],
      referralEmergencyNumber: [{
        value: communityProviderProgram.referralEmergencyNumber
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_EMERGENCY_NUMBER') }],
      referralExtension: [{
        value: communityProviderProgram.referralExtension
      }, { validators: this.getFieldValidators('REFERRAL_CONTACT_EXTENSION') }],
      address: [{
        value: communityProviderProgram.address
      }, { validators: this.getFieldValidators('ADDRESS') }],
      openingTimes: this.fb.array([]),
      channel: [{
        value: communityProviderProgram.channel ? communityProviderProgram.channel : null
      }, { validators: this.getFieldValidators('CHANNEL') }],
      acceptingDisabledPatients: [{
        value: communityProviderProgram.acceptingDisabledPatients
      }, { validators: this.getFieldValidators('ACCEPTING_DISABLED_PATIENTS') }],
      acceptingElectronicReferrals: [{
        value: communityProviderProgram.acceptingElectronicReferrals
      }, { validators: this.getFieldValidators('COACCEPTING_ELECTRONIC_REFERRALSUNTRY') }],
      acceptingNewPatients: [{
        value: communityProviderProgram.acceptingNewPatients
      }, { validators: this.getFieldValidators('ACCEPTING_NEW_PATIENTS') }],
      acceptingSelfReferrals: [{
        value: communityProviderProgram.acceptingSelfReferrals
      }, { validators: this.getFieldValidators('ACCEPTING_SELF_REFERRALS') }],
      lgbtq: [{
        value: communityProviderProgram.lgbtq
      }, { validators: this.getFieldValidators('LGBTQ') }],
      alias: [{
        value: communityProviderProgram.alias
      }, { validators: this.getFieldValidators('ALIAS') }],
      alertDescription: [{
        value: communityProviderProgram.alertDescription
      }, { validators: this.getFieldValidators('ALERT_DESCRIPTION') }],
      applicationProcess: [{
        value: communityProviderProgram.applicationProcess
      }, { validators: this.getFieldValidators('APPLICATION_PROCESS') }],
      areaServedCities: [{
        value: communityProviderProgram.areaServedCities, disabled: false
      }, { validators: this.getFieldValidators('AREAS_SERVED_CITIES') }],
      areaServedCounties: [{
        value: communityProviderProgram.areaServedCounties, disabled: false
      }, { validators: this.getFieldValidators('AREAS_SERVED_COUNTIES') }],
      areaServedZipCodes: [{
        value: communityProviderProgram.areaServedZipCodes, disabled: false
      }, { validators: this.getFieldValidators('AREAS_SERVED_ZIPCODES') }],
      capacity: [{
        value: communityProviderProgram.capacity,
      }, { validators: this.getFieldValidators('CAPACITY') }],
      documentationRequired: [{
        value: communityProviderProgram.documentationRequired,
      }, { validators: this.getFieldValidators('DOCUMENTATION_REQUIRED') }],
      incomeRequirements: [{
        value: communityProviderProgram.incomeRequirements, disabled: false
      }, { validators: this.getFieldValidators('INCOME_REQUIREMENTS') }],
      licenses: [{
        value: communityProviderProgram.licenses, disabled: false
      }, { validators: this.getFieldValidators('LICENSES') }],
      paymentMethods: [{
        value: communityProviderProgram.paymentMethods, disabled: false
      }, { validators: this.getFieldValidators('PAYMENT_METHODS') }],
      resourceStatus: [{
        value: communityProviderProgram.resourceStatus, disabled: false
      }, { validators: this.getFieldValidators('STATUS') }],
      submittingOrganization: [{
        value: communityProviderProgram.submittingOrganization, disabled: this.isRestrictedSubmittingOrganization
      }, { validators: this.getFieldValidators('SUBMITTING_ORGANIZATION') }],
      targetedDemographics: [{
        value: communityProviderProgram.targetedDemographics, disabled: false
      }, { validators: this.getFieldValidators('TARGETED_DEMOGRAPHICS') }],
      targetedPopulations: [{
        value: communityProviderProgram.targetedPopulations, disabled: false
      }, { validators: this.getFieldValidators('TARGETED_POPULATIONS') }],
      providerTaxonomies: [{
        value: communityProviderProgram.providerTaxonomies, disabled: false
      }, { validators: this.getFieldValidators('TAXONOMIES') }],
      waitTimes: this.fb.array([]),
      websites: this.fb.array([]),
      otherIdentifiers: this.fb.array([]),
      // Temporary properties below
      longitude: null,
      latitude: null,
      streetLine: [{
        value: communityProviderProgram.streetLine
      }, { validators: this.getFieldValidators('STREET') }],
      streetLineAdditional: [{
        value: communityProviderProgram.streetLineAdditional
      }, { validators: this.getFieldValidators('ADDRESS_LINE_2') }],
      city: [{
        value: communityProviderProgram.city
      }, { validators: this.getFieldValidators('CITY') }],
      postalCode: [{
        value: communityProviderProgram.postalCode
      }, { validators: this.getFieldValidators('STATE') }],
      state: [{
        value: communityProviderProgram.state
      }, { validators: this.getFieldValidators('POSTAL_CODE') }],
      country: [{
        value: communityProviderProgram.country
      }, { validators: this.getFieldValidators('COUNTRY') }],
      directoryManagerName: [{
        value: communityProviderProgram.directoryManagerName
      }, { validators: this.getFieldValidators('DIRECTORY_MANAGER_NAME') }],
      directoryManagerEmail: [{
        value: communityProviderProgram.directoryManagerEmail
      }, { validators: this.getFieldValidators('DIRECTORY_MANAGER_EMAIL') }],
      directoryManagerNotificationPreference: [{
        value: (communityProviderProgram.directoryManagerNotificationPreference)
      }, { validators: this.getFieldValidators('DIRECTORY_MANAGER_NOTIFICATION_PREFERENCE') }],
      ableToConductScreenings: [{
        value: communityProviderProgram.ableToConductScreenings
      }, { validators: this.getFieldValidators('ABLE_TO_CONDUCT_SCREENINGS') }],
      informationalOnly: [{
        value: communityProviderProgram.informationalOnly
      }, { validators: this.getFieldValidators('INFORMATIONAL_ONLY') }],
      allowDuplicateReferrals: [{
        value: communityProviderProgram.allowDuplicateReferrals ? communityProviderProgram.allowDuplicateReferrals : false
      }, { validators: [Validators.required] }],
      extensions: [{
        value: communityProviderProgram.extensions !== null ?
          communityProviderProgram.extensions : [], disabled: false
      }],
    });

    this.currentDirectoryManagerEmail = this.directoryManagerEmail.value;

    if (!this.isRequired("DIRECTORY_MANAGER_NOTIFICATION_PREFERENCE"))
    {
      this.editForm.get('directoryManagerEmail').valueChanges.subscribe({
        next: () =>
        {
          const notificationPreferenceValidator = [];
          if (this.directoryManagerEmail.value && this.directoryManagerEmail.value !== null)
          {
            notificationPreferenceValidator.push(Validators.required);
          }
          this.directoryManagerNotificationPreference.setValidators(notificationPreferenceValidator);
          this.directoryManagerNotificationPreference.updateValueAndValidity();
        }
      });
    }

    // Check if Channel is still online, if not we need to fetch this program separatly.
    const channelId = this.channel && this.channel.value ? this.channel.value.id : null;
    if (channelId !== null && channelId !== undefined)
    {
      const channelFound = this.allChannels.filter(x => x.id === channelId);
      if (channelFound.length === 0)
      {
        this.channelService.getMinimalChannelById(channelId).subscribe({
          next: (lookupChannel) =>
          {
            if (lookupChannel.length === 1)
            {
              lookupChannel.forEach(d =>
              {
                d.programName = d.program.name;
              });

              // Add Channel to allChannels array to show but will not be able to select (will be disabled)
              this.allChannels.push(lookupChannel[0]);
              this.setGroupedChannels();
            }
            else
            {
              // Skip the load since we can't retrieve the channelId.
              this.messageHandlerService.displayWarning('CHANNEL-NOT-FOUND');
            }
          }
        });
      }
    }

    if (communityProviderProgram && communityProviderProgram.openingTimes)
    {
      // First assign a sorting index
      const times = communityProviderProgram.openingTimes;
      times.forEach((data: any) =>
      {
        data.sort = this.daysConst.indexOf(data.day);
      });

      communityProviderProgram.openingTimes = sortBy(times, ['sort']);
      communityProviderProgram.openingTimes.forEach(data =>
      {
        // Must convert from/to time to javascript date
        const now = new Date();
        const nowString = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
        data.from = new Date(`${nowString} ${data.from}`);
        data.to = new Date(`${nowString} ${data.to}`);

        this.addTime(data.id, data.version, data.day, data.from, data.to);
      });
    }

    if (communityProviderProgram && communityProviderProgram.waitTimes)
    {
      // First assign a sorting index
      const locationIDs = communityProviderProgram.waitTimes;
      locationIDs.forEach((data: any) =>
      {
        data.sort = data.locationID;
      });

      communityProviderProgram.waitTimes = sortBy(locationIDs, ['sort']);
      communityProviderProgram.waitTimes.forEach(data =>
      {
        this.addWaitTime(data.id, data.version, data.locationID, data.waitTime);
      });
    }

    if (communityProviderProgram && communityProviderProgram.websites)
    {
      //First assign a sorting index
      const names = communityProviderProgram.websites;
      names.forEach((data: any) =>
      {
        data.sort = data.name;
      });

      communityProviderProgram.websites = sortBy(names, ['sort']);
      communityProviderProgram.websites.forEach(data =>
      {
        this.addWebsite(data.id, data.version, data.name, data.url);
      });
    }

    if (communityProviderProgram && communityProviderProgram.otherIdentifiers)
    {
      communityProviderProgram.otherIdentifiers = sortBy(communityProviderProgram.otherIdentifiers, ['id']);
      communityProviderProgram.otherIdentifiers.forEach(data =>
      {
        this.addOtherIdentifier(data.id, data.version, data.assigningAuthorityDictionary, data.value,
          data.typeDictionary);
      });
    }

    this.viewExtensions.setData(communityProviderProgram && communityProviderProgram.extensions ? communityProviderProgram.extensions : []);
    this.viewExtensions.setSort([{ field: 'settingExtension.name', dir: 'asc' }]);

    this.editForm.reset(communityProviderProgram);
    this.communityProviderProgramEdit = communityProviderProgram;
    this.name.setValue(communityProviderProgram.name);  // This is a work around to fix asyncValidators

    // Monitor address changes to not show address validator all the time.
    this.saving = false;
    this.addressChanged = false;
    this.editForm.get('streetLine').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });
    this.editForm.get('streetLineAdditional').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });
    this.editForm.get('city').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });
    this.editForm.get('state').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });
    this.editForm.get('country').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });
    this.editForm.get('postalCode').valueChanges.subscribe({ next: () => { this.addressChanged = true; } });

    setTimeout(() =>
    {
      // Validate user's organization and set automatically
      if (this.isNew)
      {
        this.organization.setValue(this.userOrganization);
        if (this.isRestrictedSubmittingOrganization)
        {
          this.submittingOrganization.setValue(this.userOrganization);
        }
      }
      this.editFormActive = true;
    });
  }

  private initTime(id = 0, version = 0, day: string, from: Date, to: Date): UntypedFormGroup
  {
    const group: any = {};
    group.rowId = null;
    group.id = [id];
    group.day = [day, Validators.required];
    group.from = [from, Validators.required];
    group.to = [to, Validators.required];
    group.version = version;
    return this.fb.group(group);
  }


  private initWaitTime(id = 0, version = 0, locationID: string, waitTime: string): UntypedFormGroup
  {
    const group: any = {};
    group.rowId = null;
    group.id = [id];
    group.locationID = [locationID];
    group.waitTime = [waitTime, Validators.required];
    group.version = version;
    return this.fb.group(group);
  }

  private initWebsite(id = 0, version = 0, name: string, url: string): UntypedFormGroup
  {
    const group: any = {};
    group.rowId = null;
    group.id = [id];
    group.name = [name];
    const urlValidators = [
      Validators.required,
      Validators.pattern(this.urlPattern)
    ];
    group.url = [{ value: url, disabled: false },
    {
      validators: urlValidators
    }];
    group.version = version;
    return this.fb.group(group);
  }

  private initOtherIdentifier(id = 0, version = 0, isoassigningAuthority: any, numberValue: string,
    numberType: any): UntypedFormGroup
  {
    const group: any = {};
    group.rowId = null;
    group.id = [id];
    group.value = [{ value: numberValue, disabled: false }, Validators.required];
    group.typeDictionary = [{ value: numberType, disabled: false }, Validators.required];
    group.assigningAuthorityDictionary = [{ value: isoassigningAuthority, disabled: false }];
    group.version = version;
    return this.fb.group(group);
  }

  private getOrganizations()
  {
    this.organizationService.getCachedOrganizations().subscribe({
      next: (data) =>
      {
        this.organizations = data;
        this.submittingOrganizations = data.filter(o => o.submittingOrganization === true);
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Return the required validator if the field is required.
   *
   * @param communityResource Community Resource field to check.
   * @returns Validators.required or null if the field is optional
   */
  private getFieldValidators(communityResource: string)
  {
    const fieldValidators = [];
    if (this.isRequired(communityResource))
    {
      fieldValidators.push(Validators.required);
    }
    // Add URL validator
    if (communityResource === 'PROGRAM_CONTACT_URL' || communityResource === 'REFERRAL_CONTACT_URL')
    {
      fieldValidators.push(Validators.pattern(this.urlPattern));
    }
    // Add Email Validator
    else if (communityResource === 'PROGRAM_CONTACT_EMAIL' || communityResource === 'REFERRAL_CONTACT_EMAIL')
    {
      fieldValidators.push(Validators.email);
    }
    return fieldValidators;
  }

  private performServiceSave(service: any): void
  {
    this.saving = true;
    this.serviceToSave = service;
    if (this.addressChanged && this.streetLine.value)
    {
      this.addressValidator.execute(true, this.streetLine.value, this.streetLineAdditional.value, this.city.value,
        this.state.value ? this.state.value.code : null, this.country.value ? this.country.value.code : null, this.postalCode.value);
    }
    else
    {
      this.saveService();
    }
  }
}
